import { render } from "./HeroiconsOutlineFlag.vue?vue&type=template&id=2a2054c5"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFlag.vue"]])

export default __exports__